$(document).ready(() => {
  /* funzione che estende il link a tutto il box */
  $('.linkAll').each(function() { 
      var elemToLink = $(this);
      var elemFromLink = $(this).find('a');
      var pageLink = elemFromLink.attr('href');
      var linkTarget = (typeof elemFromLink.attr('target')!=='undefined') ?  elemFromLink.attr('target') : '' ;
      var nobarba = elemFromLink.hasClass('no-barba');
      elemToLink.css('cursor','pointer')
    if(pageLink !== undefined && pageLink!=='javascript:;') {
      elemToLink.addClass('pointer').click({myLink:pageLink, myTarget:linkTarget, nobarba:nobarba},function(e){
        e.preventDefault();
        if(e.data.myTarget==='_blank'){
          window.open(e.data.myLink);
        } else {
          if(typeof barbaJs !=='undefined' && !e.data.nobarba){
            Barba.Pjax.goTo(e.data.myLink); 
          } else {
            location.href = e.data.myLink;
          }
        }
      });
    }
  })
  /* integrazione gestione bundles, se uno dei sottoprodotti ha quantità 0 disabilito Aggiungi al carrello */
  function disableAddToCartByBundle() {
    $('.product-pack').find('article').each(function(dom) {
      const data_q = parseInt($(this).data('quantity-available'));
      if(data_q == 0) $('.add-to-cart').prop('disabled',true);
    });
  }
  //disableAddToCartByBundle();
  /*prestashop.on('updateProduct', function (event) {
    setTimeout(disableAddToCartByBundle,2000);
  });*/
  // if( $('#checkout-personal-information-step').length > 0) {
  //   $('#checkout-personal-information-step').find('[name="firstname"]').val('Nome');
  //   $('#checkout-personal-information-step').find('[name="lastname"]').val('Cognome');
  // }
  
  function trickForItcInvoiceModule() {
    if( $('[name="type_address"]').length > 0 && $('[name="type_address"]').is(':visible')){
      $('[name="type_address"]').filter('[value="business"]').trigger('click');
      $('[name="type_address"]').filter('[value="private"]').trigger('click');
    }
  } 

  setTimeout(() => trickForItcInvoiceModule(), 500);

  $(document).on('change','[name="id_country"]', function(e){            
    setTimeout(() => trickForItcInvoiceModule(), 500);                
  });
  
  if($('#customer-form').length > 0){
    $('#customer-form').find('[name="email"]').on('focusout',function() {
      var inputval = $(this).val().toLowerCase();
      $(this).val( inputval );
    });
  }

  $('.slick-brand').slick({ 
    infinite: true, 
    slidesToShow: 3, 
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

  setTimeout(() => {
    $('.homeBox__visual__one').fadeIn();
  }, 1000);
  setTimeout(() => {
    $('.homeBox__visual__two').fadeIn();
  }, 1200);

  addMeasureAttrToTitle(); /*Aggiunge il valore della variante Misura al titolo*/
  addColorAttrToTitle(); /*Aggiunge il valore della variante Colore al titolo*/

});

function addMeasureAttrToTitle(){
  var prodUrl = window.location.href;

  if (prodUrl.indexOf('misura')!='-1'){
    var measure = $('#group_4 option:selected').attr('title');
    $('h1 span').append(' <b class="measure">- ' + measure + '</b>');
  }

  $(document).on('change', '#group_4', function(){
    var measure = $('#group_4 option:selected').attr('title');
    $('h1 span b.measure').remove();
    $('h1 span').append(' <b class="measure">- ' + measure + '</b>');
  });

}

function addColorAttrToTitle() {
  var prodUrl = window.location.href;

  if (prodUrl.indexOf('colore')!= '-1') {
    var color = '';
    $('.input-color').each(function(){
      if ($(this).is(':checked')){
        color = $(this).siblings('span').children().text();
      }
    });
    
    $('h1 span').append(' <b class="var-color">- ' + color + '</b>');
  }

  $(document).on('click', '.input-color', function () {
    //var color = $('.input-color:checked').parent().data('original-title');
    var color = $(this).siblings('span').children().text();
    //alert(color);
    $('h1 span b.var-color').remove();
    $('h1 span').append(' <b class="var-color">- ' + color + '</b>');
  });

}


$(document).ready(function(){

  var iqitMobileMenuNext = (function() {

    var $menu = $('#iqitmegamenu-mobile > li > .mm-expand');
    //var $expander = $menu.find('.mm-expand');
    var $expanderNext = $menu.next();

    $expanderNext.on('click', function (e) {
      e.preventDefault();
      $(this).parent().toggleClass('show');
    });
  });

  iqitMobileMenuNext();
  
});


// WEBPACK FOOTER //
// ./js/custom.js